import { render, staticRenderFns } from "./NoProducts.vue?vue&type=template&id=16d5bfc2&scoped=true&"
import script from "./NoProducts.vue?vue&type=script&lang=js&"
export * from "./NoProducts.vue?vue&type=script&lang=js&"
import style0 from "../NextButton/next-button.scss?vue&type=style&index=0&id=16d5bfc2&prod&scoped=true&lang=css&"
import style1 from "./no-products.scss?vue&type=style&index=1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d5bfc2",
  null
  
)

export default component.exports